// extracted by mini-css-extract-plugin
export default {"case--solution":"aldiana--case--solution--35oKq"};